import { render } from "./BaseTemplate.vue?vue&type=template&id=0083dd3e&ts=true"
import script from "./BaseTemplate.ts?vue&type=script&lang=ts&external"
export * from "./BaseTemplate.ts?vue&type=script&lang=ts&external"

import "./IncentiveModal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__